/** Nested topical manuals — not A–Z. */

export function topic(input) {
  return {
    slug: input.slug,
    title: input.title,
    terms: input.terms || [],
    forYou: input.forYou || "",
    how: Array.isArray(input.how) ? input.how : input.how ? [input.how] : [],
    why: input.why || "",
    examples: Array.isArray(input.examples) ? input.examples : input.examples ? [input.examples] : [],
    tips: Array.isArray(input.tips) ? input.tips : input.tips ? [input.tips] : [],
    related: input.related || [],
    href: input.href || "",
  };
}

export function group(title, children) {
  return { title, children };
}

export function flattenTree(tree, acc = []) {
  tree.forEach((item) => {
    if (item.slug) acc.push(item);
    if (item.children) flattenTree(item.children, acc);
  });
  return acc;
}

export function findTopic(tree, slug) {
  return flattenTree(tree).find((item) => item.slug === slug) || null;
}

export function haystack(item) {
  return [item.title, item.forYou, item.why, ...(item.how || []), ...(item.examples || []), ...(item.tips || []), ...(item.terms || [])]
    .join(" ")
    .toLowerCase();
}

export function searchTopics(tree, query) {
  const q = String(query || "").trim().toLowerCase();
  const all = flattenTree(tree);
  if (!q) return all;
  return all.filter((item) => haystack(item).includes(q));
}
